'use client';

import { motion, useAnimation } from 'framer-motion';
import React from 'react';
const pathVariants = {
	normal: { pathLength: 1, opacity: 1, pathOffset: 0 },
	animate: {
		opacity: [0, 1],
		pathLength: [0, 1],
		transition: {
			delay: 0.1,
			duration: 0.4,
			opacity: { duration: 0.1, delay: 0.1 },
		},
	},
};

export const UploadIcon = () => {
	const controls = useAnimation();

	return (
		<div
			className='p-2 rounded-md transition-colors duration-200 flex items-center justify-center'
			onMouseEnter={() => controls.start('animate')}
			onMouseLeave={() => controls.start('normal')}
		>
			<svg
				xmlns='http://www.w3.org/2000/svg'
				width='48'
				height='48'
				viewBox='0 0 24 24'
				fill='none'
				stroke='currentColor'
				strokeWidth='2'
				strokeLinecap='round'
				strokeLinejoin='round'
				className='text-purple-500'
			>
				<motion.path
					variants={pathVariants}
					initial='normal'
					animate={controls}
					d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4'
				/>
				<motion.polyline
					variants={pathVariants}
					initial='normal'
					animate={controls}
					points='17 8 12 3 7 8'
				/>
				<motion.line
					variants={pathVariants}
					initial='normal'
					animate={controls}
					x1='12'
					y1='3'
					x2='12'
					y2='15'
				/>
			</svg>
		</div>
	);
};
